export const EMITTER_EVENTS = {
	createPlayer: 'CREATE_PLAYER',
	createStaff: 'CREATE_STAFF',
	createTag: 'CREATE_TAG',
	createReferralCode: 'CREATE_REFERRAL_CODE',
	createPartnersProgram: 'CREATE_PARTNERS_PROGRAM',
	createPartnersTemplate: 'CREATE_PARTNERS_TEMPLATE',
	addingCurrency: 'ADDING_CURRENCY',
	addingPaymentSystem: 'ADDING_PAYMENT_SYSTEM',
	createIntegration: 'CREATE_INTEGRATION',
	createMissionLevel: 'CREATE_MISSION_LEVEL',
	createLevelGoal: 'CREATE_LEVEL_GOAL',
	createGoalConfigs: 'CREATE_GOAL_CONFIG',
	createLevelReward: 'CREATE_LEVEL_REWARD',
	createMaintenance: 'CREATE_MAINTENANCE',
	createText: 'CREATE_TEXT',
	createHall: 'CREATE_HALL',
	createMission: 'CREATE_MISSION',
	createLanguage: 'CREATE_LANGUAGE',
	createPaymentMethod: 'CREATE_PAYMENT_METHOD',
	createPromoCode: 'CREATE_PROMO_CODE',
	editText: 'EDIT_TEXT',
	imagePreview: 'IMAGE_PREVIEW',
	cropImage: 'CROP_IMAGE',
	delete: 'DELETE',
	hallStatistics: 'HALL_STATISTICS',
	addingCurrencyInCatalog: 'ADDING_CURRENCY_IN_CATALOG',
	createPromoCodeForHalls: 'CREATE_PROMO_CODE_FOR_HALLS',
	createReport: 'CREATE_REPORT',

	attachPlayer: 'PLAYER_ATTACHED',
	detachPlayer: 'PLAYER_DETACHED',

	paymentMethodCreated: 'PAYMENT_METHOD_CREATED',
	playerCreated: 'PLAYER_CREATED',
	staffCreated: 'STAFF_CREATED',
	tagCreated: 'TAG_CREATED',
	referralCodeCreated: 'REFERRAL_CODE_CREATED',
	partnersProgramCreated: 'PARTNERS_PROGRAM_CREATED',
	partnersTemplateCreated: 'PARTNERS_TEMPLATE_CREATED',
	currencyAdded: 'CURRENCY_ADDED',
	integrationCreated: 'INTEGRATION_CREATED',
	missionLevelCreated: 'MISSION_LEVEL_CREATED',
	levelGoalCreated: 'LEVEL_GOAL_CREATED',
	goalConfigsCreated: 'GOAL_CONFIG_CREATED',
	levelRewardCreated: 'LEVEL_REWARD_CREATED',
	maintenanceCreated: 'MAINTENANCE_CREATED',
	hallCreated: 'HALL_CREATED',
	textCreated: 'TEXT_CREATED',
	textEdited: 'TEXT_EDITED',
	textDeleted: 'TEXT_DELETED',
	imageCroppedSuccess: 'IMAGE_CROPPED_SUCCESS',
	deletedSuccess: 'DELETED_SUCCESS',
	languageCreated: 'LANGUAGE_CREATED',
	newCurrencyInCatalog: 'NEW_CURRENCY_IN_CATALOG',
	paymentSystemAdded: 'PAYMENT_SYSTEM_ADDED',
	promoCodeCreated: 'PROMO_CODE_CREATED',
	reportCreated: 'REPORT_CREATED',

	addingWidget: 'ADDING_WIDGET',
	widgetAdded: 'WIDGET_ADDED',
}
